import React, { useRef, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import { SuccessMessage, ErrorMessage } from '../../../../extras/toastMessages';
import clienteAxios from '../../../../../config/axios';
import { MSG_REVOKE_SUCCESS } from '../../../../../constants/messages';
import { ICON_SAVE, ICON_CANCEL } from '../../../../extras/icons';
import ButtonSpinner from '../../../../layout/ButtonSpinner'
//Axios
import { useDispatch, useSelector } from 'react-redux';
import { revokeAudiencesAction } from '../../../../../actions/audiencesActions';
//Función principal
const RevokeForm = props => {
    //Tomo los props
    const { show, handleClose, audience } = props;
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Genero los ref
    const refObservacion = useRef();
    //Inicializo datos
    const initialData = {
        audienciaId: audience.id,
        observacion: ''
    }
    //Traigo el store
    const loading = useSelector(state => state.audiences.audienceLoading);
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refObservacion.current.focus();
    }
    //Manejo el guardado
    const handleSave = async values => {
        //Armo los datos
        const data = {
            audienciaId: audience.id,
            observacionRechazo: values.observacion
        }
        //Llamo al dispatch
        dispatch( revokeAudiencesAction(audience, data) );
    }
    //Esquema de validación
    const validationSchema = yup.object({
        observacion: yup.string().required()
    });
    //Renderizo
    return (
        <Modal
            show={show} 
            onHide={handleClose} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Revocar Audiencia #{ audience.id }
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...initialData }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Seleccione el <strong>Motivo</strong> e ingrese una <strong>observación</strong>
                                    </div>
                                </div>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        id="observacion"
                                        className="form-control" 
                                        autoFocus 
                                        name="observacion" 
                                        type="text" 
                                        placeholder="Ingrese observación"
                                        value={ values.observacion }
                                        onChange={handleChange}
                                        ref={refObservacion}
                                        isInvalid={!!errors.observacion}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.observacion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="danger" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>REVOCAR</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default RevokeForm;